export enum Status {
  NOT_APPLY,
  APPLIED,
}
